import EOrderingLogo from "@assets/images/eOrdering.png";
import SCGP_Color from "@assets/images/SCGP-color.svg";
import { Button, Paper } from "@material-ui/core";
import { ClassNameMap } from "@material-ui/styles";
import HeadColored from "@saleor/components/HeadColored";
import MyTypography from "@saleor/components/MyTypography";
import useNavigator from "@saleor/hooks/useNavigator";
import { makeStyles } from "@saleor/macaw-ui";
import cls from "classnames";
import React, { FC } from "react";
import { FormattedMessage } from "react-intl";

const useStyle = makeStyles(
  theme => ({
    paper: {
      width: "560px",
      padding: "48px 24px 46px",
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      margin: "0 auto",
      borderRadius: "1.6rem",
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)"
    },
    caption: {
      color: theme.palette.grey[900],
      marginBottom: "1.2rem"
    },
    mainPanel: {
      background: "transparent"
    },
    headTextLogo: {
      margin: "120px 0",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      transition: "all 0.5s ease"
    },
    text: {
      color: "#E41B17",
      fontWeight: "bold",
      fontSize: 30,
      padding: "5px 15px",
      borderRight: "solid 1px #E41B17"
    },
    logo: {
      marginLeft: 20
    }
  }),
  { name: "OrderBlockCreate" }
);
interface OrderBlockCreateProp {
  className?: string;
  styles?: ClassNameMap<"container" | "root" | "footer">;
}

const OrderBlockCreate: FC<OrderBlockCreateProp> = ({ className, styles }) => {
  const classes = useStyle();
  const navigate = useNavigator();
  return (
    <>
      <HeadColored fixedTop />
      <div className={styles.container}>
        <div className={styles.root}>
          <div className={classes.mainPanel}>
            <div className={classes.headTextLogo}>
              <div className={classes.text}>
                <img src={SCGP_Color} alt={"logo_scg"} />
              </div>
              <div className={classes.logo}>
                <img src={EOrderingLogo} alt={"logo"} />
              </div>
            </div>
            <Paper className={cls(classes.paper, className)}>
              <MyTypography variant="h6" className={classes.caption}>
                The system is processing orders...
              </MyTypography>
              <MyTypography variant="body2">
                กรุณาตรวจสอบผลการดำเนินการของท่านที่เมนู Search Order/Inquiry -
                Order Confirmation หรือ ติดต่อ Customer Services: (02-586-5555
                กด 11)
              </MyTypography>
              <Button
                onClick={() => navigate("/")}
                variant={"contained"}
                color={"secondary"}
              >
                <MyTypography variant="button2">
                  <FormattedMessage defaultMessage={"OK"} />
                </MyTypography>
              </Button>
            </Paper>
          </div>
        </div>
        <footer className={styles.footer}>
          <MyTypography variant="body3" style={{ color: "#333333" }}>
            COPYRIGHT 2022 SCG PACKAGING. ALL RIGHTS RESERVED.
          </MyTypography>
        </footer>
      </div>
    </>
  );
};

export default OrderBlockCreate;
